export const USTerritories = [
  'AS', // American Samoa
  'FM', // Federated States of Micronesia
  'GU', // Guam
  'MH', // Marshall Islands
  'MP', // Northern Mariana Islands
  'PR', // Puerto Rico
  'PW', // Palau
  'VI', // U.S. Virgin Islands
  'UM' // U.S. Minor Outlying Islands
]
